import api from "./api";
import { JSONContent } from "@tiptap/react";

export interface PublicBlog {
  id: string;
  Title: string;
  Slug: string;
  Excerpt: string;
  Category: string;
  IsFeatured?: boolean;
  CoverImage: string | null;
  Content?: JSONContent;
  PublishedAt: string | null;
  CreatedBy: string | null;
}

export const getPublishedBlogs = async (): Promise<PublicBlog[]> => {
  const response = await api.get("/blogs/public");
  return response.data.data || [];
};

export const getPublishedBlog = async (slug: string): Promise<PublicBlog> => {
  const response = await api.get(`/blogs/public/${slug}`);
  return response.data.data;
};
